module.exports = __webpack_public_path__ + "static/media/pastorrolando.407497ff.jpg";